import { render } from "./ViewsOrderSubmit.vue?vue&type=template&id=466be0cd"
import script from "./ViewsOrderSubmit.vue?vue&type=script&lang=js"
export * from "./ViewsOrderSubmit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__